import makeStyles from '@mui/styles/makeStyles';
//This function parse hexcolor to RGB to confirm the color is light or dark and return the correct color to contrast
function getContrastYIQ(hexcolor) {
  hexcolor = hexcolor.replace('#', '');
  let r = parseInt(hexcolor.substr(0, 2), 16);
  let g = parseInt(hexcolor.substr(2, 2), 16);
  let b = parseInt(hexcolor.substr(4, 2), 16);
  let yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#000000' : '#FFFFFF';
}
const useStyles = makeStyles(theme => {
  const { palette, typography } = theme;
  const { pxToRem } = typography;

  return {
    alert: {
      marginBottom: pxToRem(10),
      width: 'auto',
      '&.MuiAlert-filledWarning': {
        backgroundColor: palette.primary.main,
        color: getContrastYIQ(palette.primary.main)
      }
    }
  };
});

export { useStyles };
